import { Button, Group, Space, Stack } from "@mantine/core";
import { Text } from "../ui/Text";
import { lawhubPrimary, lawhubSecondary } from "@/styles/colors";
import { Image } from "../ui/Image";
import { useIsLaptopOrBigger, useStyles } from "@/styles/useStyles";
import { IconArrowRight } from "@tabler/icons-react";
import { Analytics } from "@/services/Analytics";
import { useMemo } from "react";

export function LawHubBanner({
  stacked,
  maxWidth,
  context = "advize",
}: {
  stacked?: boolean;
  maxWidth?: number;
  context?: string;
}) {
  const { theme } = useStyles();
  const isLaptopOrBigger = useIsLaptopOrBigger();

  const adLink = useMemo(() => {
    return `https://app.lawhub.org?utm_source=advize&utm_medium=referral&utm_campaign=advize_launch&utm_term=advize&utm_content=${context}`;
  }, [context]);

  const logoSize = useMemo(() => {
    if (isLaptopOrBigger) {
      return stacked ? 120 : 70;
    }

    return 120;
  }, [isLaptopOrBigger, stacked]);

  const Logo = useMemo(() => {
    return (
      <Image
        src="https://static.wixstatic.com/media/ff2a77_09ebd8abc8064b0f8ef299a38347aa3a~mv2.avif"
        alt="LawHub Logo"
        width={logoSize}
        fit="contain"
      />
    );
  }, [logoSize]);

  const CTAButton = useMemo(() => {
    return (
      <Button
        color={lawhubSecondary[9]}
        size={stacked ? "md" : isLaptopOrBigger ? "sm" : "sm"}
        rightSection={<IconArrowRight size={14} />}
        radius="xl"
        maw={stacked ? 300 : 300}
        w={stacked || !isLaptopOrBigger ? "100%" : "auto"}
        mx={!isLaptopOrBigger ? "auto" : undefined}
        onClick={() => {
          Analytics.adLinkClick({
            action: "click",
            label: "lawhub_banner",
            partner: "lawhub",
            partnerId: "lawhub",
            partnerSlug: "lawhub",
            link: adLink,
            context,
          });
          window.open(adLink, "_blank");
        }}
      >
        Learn More
      </Button>
    );
  }, [adLink, context, isLaptopOrBigger, stacked]);

  return null;

  if (!isLaptopOrBigger || stacked) {
    return (
      <Group px="md" w="100%" h="100%" align="stretch" maw={maxWidth}>
        <Stack
          w="100%"
          gap={0}
          align="center"
          justify="center"
          bg={lawhubPrimary[9]}
          px="md"
          py="xl"
          style={{
            borderRadius: theme.radius.sm,
            boxShadow: theme.shadows.xl,
          }}
        >
          {Logo}
          <Text
            titleStyle={stacked ? "h3" : isLaptopOrBigger ? "h5" : "h4"}
            fw={700}
            c={theme.colors.text[0]}
            ta="center"
            pl="sm"
          >
            Considering a career in law? {isLaptopOrBigger ? <br /> : " "}
          </Text>
          <Space h="md" />
          {CTAButton}
        </Stack>
      </Group>
    );
  }

  return (
    <Group
      justify="space-between"
      align="center"
      wrap="nowrap"
      gap="lg"
      bg={lawhubPrimary[9]}
      w="100%"
      flex={1}
      px="lg"
      py="sm"
      maw={maxWidth}
      style={{
        borderRadius: theme.radius.sm,
        boxShadow: theme.shadows.xl,
      }}
    >
      <Group wrap="nowrap" flex={1} w="100%">
        <Text titleStyle="h4" fw={700} c={theme.colors.text[0]} ta="left">
          Considering a career in law? {isLaptopOrBigger ? <br /> : " "}
        </Text>
        {CTAButton}
      </Group>

      {Logo}
    </Group>
  );
}
